import { authAPI } from './api';
import type { User } from '../types';


export const authService = {
  async startFeishuLogin(): Promise<void> {
    const response = await authAPI.authorizeFeishu();
    window.location.assign(response.data.authorization_url);
  },

  async completeFeishuLogin(code: string, state: string): Promise<User> {
    const response = await authAPI.callbackFeishu({ code, state });
    return response.data.user;
  },

  async getCurrentUser(): Promise<User> {
    const response = await authAPI.getCurrentUser();
    return response.data;
  },

  async logout(): Promise<void> {
    await authAPI.logout();
  }
};

export default authService;
